import { hexToCSSFilter } from 'hex-to-css-filter';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { getFontURL } from 'src/utils/getFontUrl';

export const MultipleChoiceSurveyStyles = () => {
  const templateWidth = useSelector(
    (state: any) => state.template.templateWidth
  );
  const templateHeight = useSelector(
    (state: any) => state.template.templateHeight
  );

  const currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const CLOSE_FILTER = bgColor?.close?.[currentIndex]
    ? hexToCSSFilter(bgColor?.close?.[currentIndex])
    : { filter: '' };
  const BACK_FILTER = bgColor?.back?.[currentIndex]
    ? hexToCSSFilter(bgColor?.back?.[currentIndex])
    : { filter: '' };

  const titleFontURL = getFontURL(fontFamily?.title);
  const sub_titleFontURL = getFontURL(fontFamily?.sub_title);
  const option_buttonFontURL = getFontURL(btnFontFamily?.option_button);
  const selected_option_buttonFontURL = getFontURL(
    btnFontFamily?.selected_option_button
  );
  const buttonFontURL = getFontURL(btnFontFamily?.button);
  const selected_buttonFontURL = getFontURL(btnFontFamily?.selected_button);
  return `
    @font-face {
      font-family: 'titleFont';
      src: url('${titleFontURL}');
    }
    @font-face {
      font-family: 'sub_titleFont';
      src: url('${sub_titleFontURL}');
    }
    @font-face {
      font-family: 'option_buttonFont';
      src: url('${option_buttonFontURL}');
    }
    @font-face {
      font-family: 'selected_option_buttonFont';
      src: url('${selected_option_buttonFontURL}');
    }
    @font-face {
      font-family: 'buttonFont';
      src: url('${buttonFontURL}');
    }
    @font-face {
      font-family: 'selected_buttonFont';
      src: url('${selected_buttonFontURL}');
    }
    .root_view {
      width: 100%;
      height: 100%;

      display: flex;
      align-items: center;
      justify-content: center;

      background-repeat: no-repeat;
      background-size: cover !important;
      background-position: center !important;
      background: #fff;

      ${
        bg?.background === 'image'
          ? `background-image: url(${bgImage?.background?.[currentIndex]})`
          : `background: ${bgColor?.background?.[currentIndex]}`
      };
      
      .center_horizon {
        width: 80%;
        max-width: 300px;

        position: absolute;
        left: 50%;
        transform: translate(-50%, 0%);
      }

      .template {
        width: 100%;
        max-width: 375px;
        height: 100%;
        max-height: 812px;
        position: relative;
      }
        
      .top_wrapper {
        width: 100%;
        top: 6%;
        display: flex;
        justify-content: space-between;
      }
      .back_btn,
      .close_btn {
        width: 1.5rem;
        height: 1.5rem;
        
        background-image: url("https://image.inappmessage.com/sample/black-close.png");
        background-repeat: no-repeat;
        background-size: 1.5rem;
        background-position: center;
        filter: ${CLOSE_FILTER.filter};
  
        font-size: 0;
        border: none;
        background-color: transparent;
      }
      .back_btn {
        background-image: url("https://image.inappmessage.com/sample/arrow-sm-left.png");
        filter: ${BACK_FILTER.filter};
      }

      .center_wrapper {
        width: 100%;
        padding: 0 10%;

        display: flex;
        flex-direction: column;
        gap: 2rem;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .center_wrapper .title {
        width: 100%;
        height: 4rem;
        margin-bottom: 0.5rem;

        display: flex;
        justify-content: center;
        align-items: center;

        text-align: ${textAlign?.title};
        color: ${color?.title};
        font-size: ${fontSize?.title}rem;
        font-weight: ${fontWeight?.title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.title
          )
            ? fontFamily?.title
            : 'titleFont'
        };
      }
      .center_wrapper .title_inner {
        width: 100%;

        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .center_wrapper .sub_title {
        width: 100%;
        height: 4rem;

        display: flex;
        align-items: center;

        text-align: ${textAlign?.sub_title};
        color: ${color?.sub_title};
        font-size: ${fontSize?.sub_title}rem;
        font-weight: ${fontWeight?.sub_title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.sub_title
          )
            ? fontFamily?.sub_title
            : 'sub_titleFont'
        };
      }
      .center_wrapper .sub_title_inner {
        width: 100%;

        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
      }

      .survey_wrapper {
        width: 100%;
        height: auto;

        display: flex;
        flex-direction: column;
        gap: 1rem;
      }
      .survey_action_line {
        width: 0%;
        height: 4px;
        position: absolute;
        background: #333;
        transition: all ease 0.5s 0s;
      }
      .survey_line {
        width: 100%;
        height: 4px;
        position: relative;
        background: #f2f2f2;
      }
      .survey button {
        width: 100%;
        height: 3rem;
        border: 0;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        font-size: ${btnFontSize?.option_button}rem;
        font-weight: ${btnFontWeight?.option_button};
        color: ${btnColor?.option_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.option_button
          )
            ? btnFontFamily?.option_button
            : 'option_buttonFont'
        };
        border-radius: ${radius?.option_button}px;
        background-color:rgba(${btnBgColorR?.option_button},${
    btnBgColorG?.option_button
  }, ${btnBgColorB?.option_button}, ${btnBgColorA?.option_button});
      }
      .survey button.action {
        font-size: ${btnFontSize?.selected_option_button}rem;
        font-weight: ${btnFontWeight?.selected_option_button};
        color: ${btnColor?.selected_option_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.selected_option_button
          )
            ? btnFontFamily?.selected_option_button
            : 'selected_option_buttonFont'
        };
        border-radius: ${radius?.selected_option_button}px;
        background-color:rgba(${btnBgColorR?.selected_option_button},${
    btnBgColorG?.selected_option_button
  }, ${btnBgColorB?.selected_option_button}, ${
    btnBgColorA?.selected_option_button
  });
      }

      .btn_wrapper {
        width: 80%;
        position: absolute;
        bottom: 2rem;
      }
      .btn_wrapper button {
        width: 100%;
        height: 3rem;
        outline: 0;
        border: 0;

        color: ${btnColor?.button};
        font-size: ${btnFontSize?.button}rem;
        font-weight: ${btnFontWeight?.button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.button
          )
            ? btnFontFamily?.button
            : 'buttonFont'
        };
        border-radius: ${radius?.button}px;
        background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
      }      
      .btn_wrapper button.action {
        color: ${btnColor?.selected_button};
        font-size: ${btnFontSize?.selected_button}rem;
        font-weight: ${btnFontWeight?.selected_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.selected_button
          )
            ? btnFontFamily?.selected_button
            : 'selected_buttonFont'
        };
        border-radius: ${radius?.selected_button}px;
        background-color:rgba(${btnBgColorR?.selected_button},${
    btnBgColorG?.selected_button
  }, ${btnBgColorB?.selected_button}, ${btnBgColorA?.selected_button});
      }
    }
  `;
};
